export default function getArrayFromQuery(query){
    if(typeof query === 'string'){
        return [query];
    }
    return [...query];
}